export const Development = 
{
    Metadata:{Name:'Development',maxColumn:4,numRows:5},
    Sections:
    [
        {
            Headers:[
                "Developmental History: Please check all appropriate boxes",
                "Yes",
                "No",
                "Unsure",
                "Comments"
            ],
            Questions:[
                {
                    Prompt:"Premature Birth",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Delay in talking (if yes specify age you started talking)",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Delay in walking (if yes specify age you started walking)",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Held back in school",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Had a IEP in school",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
            ]
        }
    ]
}